import { render, staticRenderFns } from "./updateBack.vue?vue&type=template&id=35b999a2&scoped=true"
import script from "./updateBack.vue?vue&type=script&lang=js"
export * from "./updateBack.vue?vue&type=script&lang=js"
import style0 from "./updateBack.vue?vue&type=style&index=0&id=35b999a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b999a2",
  null
  
)

export default component.exports